<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-credit-card"></i> Expense Management</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <button class="btn btn-primary btn-sm" [routerLink]="['/dashboard/expenses']"><i class="fa fa-arrow-left"> Back</i></button>
                </div>
            </div>
            <!--end header-->
            <ul class="nav nav-tabs nav-tabs-bottom">
                <li class="nav-item"><a class="nav-link active" href="#expence-tab1" data-toggle="tab"><i class="fa fa-plus"></i> Add Expense</a></li>
                <li class="nav-item"><a class="nav-link" href="#expence-tab2" data-toggle="tab"><i class="fa fa-object-group"></i> Bulk Add Expense</a></li>
             </ul>
            
             <div class="tab-content m-t-10">
                <nav class="tab-pane active" id="expence-tab1">
                  <div class="row row-replace">
                      <div class="col-md-6 card pt-10">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-4">
                                    <label for="aaaa">Expense Type<span class="text-danger">*</span></label>
                                </div>
                                <div class="col-8">
                                   <select class="form-control">
                                       <option>one</option>
                                       <option>one</option>
                                       <option>one</option>
                                       <option>one</option>
                                   </select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-4">
                                    <label for="aaaa">Month / Date<span class="text-danger">*</span></label>
                                </div>
                                <div class="col-8">
                                  <input type="date" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-4">
                                    <label for="aaaa">Attach Bill/ Attach Payment receipt<span class="text-danger">*</span></label>
                                </div>
                                <div class="col-8">
                                  <input type="file" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-4">
                                    <label for="aaaa">Amount<span class="text-danger">*</span></label>
                                </div>
                                <div class="col-8">
                                  <input type="text" class="form-control" placeholder="Amount">
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-4">
                                    <label for="aaaa">PC Code<span class="text-danger">*</span></label>
                                </div>
                                <div class="col-8">
                                  <input type="text" class="form-control" placeholder="enter pc code">
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-4">
                                    <label for="aaaa">Mode of Transport<span class="text-danger">*</span></label>
                                </div>
                                <div class="col-8">
                                 <select class="form-control">
                                     <option>Auto</option>
                                     <option>Bus</option>
                                     <option>Metro</option>
                                     <option>OLA</option>
                                     <option>UBER</option>
                                     <option>Other public Tranport</option>
                                 </select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-4">
                                    <label for="aaaa">Remark<span class="text-danger">*</span></label>
                                </div>
                                <div class="col-8">
                                 <textarea rows="3" class="form-control"></textarea>
                                </div>
                            </div>
                        </div>
                       

                      </div>
                      <div class="col-md-6 card">
                        <div class="form-group text-center">
                            <div class="upload-btn-wrapper re-size-upload">
                                <input type="file">
                                <span class="fa fa-upload fa-5x"></span>
                                <p class="text-danger">Only pdf files are <br>allowed to upload.</p>
                                
                            </div>
                        </div>

                    </div>
                  </div>
                  <div class="row">
                      <div class="col-12 text-center">
                          <button class="btn btn-primary btn-sm">Submit</button>
                          <button class="btn btn-danger btn-sm ml-10">Cancel</button>
                      </div>
                  </div>


                </nav>
                <nav class="tab-pane" id="expence-tab2">
                    <div class="table-responsive">
                        <table class="table">
                            <tr class="bg-primary text-white">
                               <th>Expense Type</th>
                               <th>Expense Date	</th>
                               <th>Amount</th>
                               <th>PC Code</th>
                               <th>Remarks</th>
                               <th>Upload Invoice</th>
                               <th>Transport Mode</th>
                               <th>Action</th>
                            </tr>
                            <tr>
                                <td>
                                    <select class="form-control">
                                        <option>Meal Expense</option>
                                        <option>Traval Expense</option>
                                        <option>Other Expense</option>
                                    </select>
                                </td>
                                <td><input type="date" class="form-control"></td>
                                <td><input type="text" class="form-control" placeholder="INR"></td>
                                <td><input type="text" class="form-control" placeholder="PC Code"></td>
                                <td><input type="text" class="form-control" placeholder="Remarks"></td>
                                <td><input type="file" class="form-control"></td>
                                <td>
                                    <select class="form-control">
                                        <option>Auto</option>
                                        <option>Bus</option>
                                        <option>Metro</option>
                                        <option>OLA</option>
                                        <option>UBER</option>
                                        <option>Other public Tranport</option>
                                    </select>
                                </td>
                                <td>
                                    <div class="btn-group btn-group-sm">
                                        <button class="btn-danger"><i class="fa fa-pencil-square-o"></i></button>
                                        <button class="btn-primary"><i class="fa fa-trash-o"></i></button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <select class="form-control">
                                        <option>Meal Expense</option>
                                        <option>Traval Expense</option>
                                        <option>Other Expense</option>
                                    </select>
                                </td>
                                <td><input type="date" class="form-control"></td>
                                <td><input type="text" class="form-control" placeholder="INR"></td>
                                <td><input type="text" class="form-control" placeholder="PC Code"></td>
                                <td><input type="text" class="form-control" placeholder="Remarks"></td>
                                <td><input type="file" class="form-control"></td>
                                <td>
                                    <select class="form-control">
                                        <option>Auto</option>
                                        <option>Bus</option>
                                        <option>Metro</option>
                                        <option>OLA</option>
                                        <option>UBER</option>
                                        <option>Other public Tranport</option>
                                    </select>
                                </td>
                                <td>
                                    <div class="btn-group btn-group-sm">
                                        <button class="btn-danger"><i class="fa fa-pencil-square-o"></i></button>
                                        <button class="btn-primary"><i class="fa fa-trash-o"></i></button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <select class="form-control">
                                        <option>Meal Expense</option>
                                        <option>Traval Expense</option>
                                        <option>Other Expense</option>
                                    </select>
                                </td>
                                <td><input type="date" class="form-control"></td>
                                <td><input type="text" class="form-control" placeholder="INR"></td>
                                <td><input type="text" class="form-control" placeholder="PC Code"></td>
                                <td><input type="text" class="form-control" placeholder="Remarks"></td>
                                <td><input type="file" class="form-control"></td>
                                <td>
                                    <select class="form-control">
                                        <option>Auto</option>
                                        <option>Bus</option>
                                        <option>Metro</option>
                                        <option>OLA</option>
                                        <option>UBER</option>
                                        <option>Other public Tranport</option>
                                    </select>
                                </td>
                                <td>
                                    <div class="btn-group btn-group-sm">
                                        <button class="btn-danger"><i class="fa fa-pencil-square-o"></i></button>
                                        <button class="btn-primary"><i class="fa fa-trash-o"></i></button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <select class="form-control">
                                        <option>Meal Expense</option>
                                        <option>Traval Expense</option>
                                        <option>Other Expense</option>
                                    </select>
                                </td>
                                <td><input type="date" class="form-control"></td>
                                <td><input type="text" class="form-control" placeholder="INR"></td>
                                <td><input type="text" class="form-control" placeholder="PC Code"></td>
                                <td><input type="text" class="form-control" placeholder="Remarks"></td>
                                <td><input type="file" class="form-control"></td>
                                <td>
                                    <select class="form-control">
                                        <option>Auto</option>
                                        <option>Bus</option>
                                        <option>Metro</option>
                                        <option>OLA</option>
                                        <option>UBER</option>
                                        <option>Other public Tranport</option>
                                    </select>
                                </td>
                                <td>
                                    <div class="btn-group btn-group-sm">
                                        <button class="btn-danger"><i class="fa fa-pencil-square-o"></i></button>
                                        <button class="btn-primary"><i class="fa fa-trash-o"></i></button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <select class="form-control">
                                        <option>Meal Expense</option>
                                        <option>Traval Expense</option>
                                        <option>Other Expense</option>
                                    </select>
                                </td>
                                <td><input type="date" class="form-control"></td>
                                <td><input type="text" class="form-control" placeholder="INR"></td>
                                <td><input type="text" class="form-control" placeholder="PC Code"></td>
                                <td><input type="text" class="form-control" placeholder="Remarks"></td>
                                <td><input type="file" class="form-control"></td>
                                <td>
                                    <select class="form-control">
                                        <option>Auto</option>
                                        <option>Bus</option>
                                        <option>Metro</option>
                                        <option>OLA</option>
                                        <option>UBER</option>
                                        <option>Other public Tranport</option>
                                    </select>
                                </td>
                                <td>
                                    <div class="btn-group btn-group-sm">
                                        <button class="btn-danger"><i class="fa fa-pencil-square-o"></i></button>
                                        <button class="btn-primary"><i class="fa fa-trash-o"></i></button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <select class="form-control">
                                        <option>Meal Expense</option>
                                        <option>Traval Expense</option>
                                        <option>Other Expense</option>
                                    </select>
                                </td>
                                <td><input type="date" class="form-control"></td>
                                <td><input type="text" class="form-control" placeholder="INR"></td>
                                <td><input type="text" class="form-control" placeholder="PC Code"></td>
                                <td><input type="text" class="form-control" placeholder="Remarks"></td>
                                <td><input type="file" class="form-control"></td>
                                <td>
                                    <select class="form-control">
                                        <option>Auto</option>
                                        <option>Bus</option>
                                        <option>Metro</option>
                                        <option>OLA</option>
                                        <option>UBER</option>
                                        <option>Other public Tranport</option>
                                    </select>
                                </td>
                                <td>
                                    <div class="btn-group btn-group-sm">
                                        <button class="btn-danger"><i class="fa fa-pencil-square-o"></i></button>
                                        <button class="btn-primary"><i class="fa fa-trash-o"></i></button>
                                    </div>
                                </td>
                            </tr>
                        </table>

                     </div>
                     <div class="row">
                        <div class="col-12">
                            <button class="btn btn-sm"><i class="fa fa-plus"></i> Add more expense</button>
                        </div>
                    </div>
                     <div class="row">
                        <div class="col-12 text-center">
                            <button class="btn btn-primary btn-sm">Submit</button>
                            <button class="btn btn-danger btn-sm ml-10">Cancel</button>
                        </div>
                    </div>
                   
                 </nav>
    
    
             </div>
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

